import { Player, RoundScore } from '../types';

export const calculateRoundScore = (bid: number, tricks: number): number => {
  // Each trick is worth 1 point
  const trickPoints = tricks;
  
  // If bid equals tricks, get 10 bonus points
  const bonusPoints = bid === tricks ? 10 : 0;
  
  return trickPoints + bonusPoints;
};

export const calculateTotalScore = (rounds: RoundScore[]): number => {
  return rounds.reduce((total, round) => total + round.score, 0);
};

export const getMaxBidForRound = (roundNumber: number, numPlayers: number): number => {
  // In Oh Hell, the maximum bid is the number of cards dealt
  // which increases each round from 1 up to the maximum cards per player
  const totalCards = 52;
  const cardsPerPlayer = Math.floor(totalCards / numPlayers);
  
  return Math.min(roundNumber, cardsPerPlayer);
};

export const validateBid = (bid: number, roundNumber: number, numPlayers: number): boolean => {
  const maxBid = getMaxBidForRound(roundNumber, numPlayers);
  return bid >= 0 && bid <= maxBid;
};

export const getRoundWinner = (players: Player[]): Player | null => {
  if (players.length === 0) return null;
  
  return players.reduce((winner, player) => {
    return player.totalScore > winner.totalScore ? player : winner;
  });
};

export const generatePlayerId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

export const generateGameId = (): string => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
}; 